import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';

import { useAiQuotaExceededModal } from '../context/AiQuotaExceededModalContext';

const AiQuotaExceededModalBody: FC = () => {
  const { t } = useTranslate();
  const { data } = useAiQuotaExceededModal();

  const formatter = new Intl.NumberFormat('es-ES');

  return (
    <Modal.Body>
      <p>{t('AI_QuotaExceededMessage')}</p>
      <ul>
        <li>
          {t('AI_Used')}:{' '}
          <strong>{formatter.format(data.used)}</strong> {t('AI_Tokens')}
        </li>
        <li>
          {t('AI_Limit')}:{' '}
          <strong>{formatter.format(data.limit)}</strong> {t('AI_Tokens')}
        </li>
        <li>
          {t('AI_CurrentPlan')}: <strong>{data.tier.toUpperCase()}</strong>
        </li>
      </ul>
    </Modal.Body>
  );
};

export default AiQuotaExceededModalBody;
